import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import { makeStyles } from "@material-ui/core/styles";
import BajaMultiple from "../../BajaMultiple";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ListadoOrdenesCorte() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  // Agregar Tela a Orden de Corte
  const URL_TELAS_ORDENES_CORTE = process.env.REACT_APP_URL_TELAS_ORDENES_CORTE;
  const URL_TELAS_ORDENES_CORTES_ACUMULADOS =
    process.env.REACT_APP_URL_TELAS_ORDENES_CORTES_ACUMULADOS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_HABILITACION_ORDENES_CORTES = process.env.REACT_APP_URL_HABILITACION_ORDENES_CORTES;
  const URL_DETALLE_HABILITACION_ORDENES_CORTES = process.env.REACT_APP_URL_DETALLE_HABILITACION_ORDENES_CORTES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [ordenesCorte, setOrdenesCorte] = useState([]);

  const [inventarios, setInventarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [selectedCortado, setSelectedCortado] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalEditObserv, setModalEditObserv] = useState(false);
  const toggleEditObserv = () => setModalEditObserv(!modalEditObserv);
  const [fechaEntregaEdit, setFechaEntregaEdit] = useState("");
  const [observacionesTelasEdit, setObservacionesTelasEdit] = useState("");

  const [articulosEdit, setArticulosEdit] = useState([]);
  const [total_piezas, setTotalPiezas] = useState(0);

  const classes = useStyles();

  const [validaBoton, setValidaBoton] = useState(true);

  const [fechaTelas, setFechaTelas] = useState(endDate);
  const [fechaEntrega, setFechaEntrega] = useState("Sin fecha");
  const [observacionesTelas, setObservacionesTelas] = useState("NA");
  const [observacionesTelasPDF, setObservacionesTelasPDF] = useState("");
  const [selectedOrdenPedido, setSelectedOrdenPedido] = useState("");
  const [selectedOrdenCorte, setSelectedOrdenCorte] = useState("");
  const [selectedOrdenCorteNumero, setSelectedOrdenCorteNumero] = useState("");
  const [totalMetros, setTotalMetros] = useState("");
  const [totalKilos, setTotalKilos] = useState("");
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);
  const [articulosOrden, setArticulosOrden] = useState([]);
  const [rollosTotales, setRollosTotales] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [modalTelas, setModalTelas] = useState(false);
  const toggleTelas = () => setModalTelas(!modalTelas);

  const [modalTelasConsumo, setModalTelasConsumo] = useState(false);
  const toggleTelasConsumo = () => setModalTelasConsumo(!modalTelasConsumo);
  const [explosion, setExplosion] = useState([]);
  const [idEdit, setIdEdit] = useState("");
  const [numero_pedido, setNumeroPedido] = useState("");
  const [modalExplosion, setModalExplosion] = useState(false);
  const toggleExplosion = () => setModalExplosion(!modalExplosion);

  const [telasDevolucion, setTelasDevolucion] = useState("");
  const [idsInventario, setIdsInventario] = useState("");
  const [selectedOrdenCorteDev, setSelectedOrdenCorteDev] = useState("");
  const [selectedOrdenCorteNumeroDev, setSelectedOrdenCorteNumeroDev] =
    useState("");
  const [modalTelasDev, setModalTelasDev] = useState(false);
  const toggleTelasDev = () => setModalTelasDev(!modalTelasDev);
  const [rollosTotalesDev, setRollosTotalesDev] = useState(0);

    const [entregaHabilitacion, setEntregaHabilitacion] = useState(false);
    const [habilitacion, setHabilitacion] = useState([]);

    const [modalHabilitacion, setModalHabilitacion] = useState(false);
    const toggleHabilitacion = () => setModalHabilitacion(!modalHabilitacion);
    const [idProcesosSalidaHab, setIdProcesosSalidaHab] = useState("");
    const [idCorteHab, setIdCorteHab] = useState("");
    const [idPedidoHab, setIdPedidoHab] = useState("");
    const [idProveedorHab, setIdProveedorHab] = useState("");
    const [fechaHab, setFechaHab] = useState("");
    const [observacionesHab, setObservacionesHab] = useState("");

    const [inputFieldsHabilitacion, setInputFieldsHabilitacion] = useState([
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0,
      },
    ]);

      const [editHab, setEditHab] = useState([]);
        const [modalEditHab, setModalEditHab] = useState(false);
        const toggleEditHab = () => setModalEditHab(!modalEditHab);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idInventarioTelas: "",
      telas: "",
      idTela: "",
      unidad: "",
      colores: "",
      idColor: "",
      cantidadOriginal: 0,
      cantidad: 0,
      idArticulo: "",
      compras: "",
      telasOC: "",
      telaCodigo: "",
      telaNombre: "",
      telaColor: "",
      bies: "No",
    },
  ]);

  const [inputFieldsAnterior, setInputFieldsAnterior] = useState([]);

  const [inputFieldsAnteriorConsumo, setInputFieldsAnteriorConsumo] = useState([]);
  useMemo(() => {
    axios
      .get(
        `${URL_ORDENES_CORTE}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let allOrdenes = response.data;
        // Array para pagination
        let arrayTabla = allOrdenes
          .sort((a, b) => (a.numero < b.numero ? 1 : -1))
          .map((a) => {
             const cantidad = a.is_active === "No" ? 0 : a.cantidad;
             // Orden con pedido (flujo viejo) vs orden directa sin pedido (flujo nuevo)
             const ped = a.pedidos && a.pedidos[0] ? a.pedidos[0] : null;
             // El artículo viene del pedido o, si es directa, del propio campo de la orden
             const art = ped && ped.articulos && ped.articulos[0]
               ? ped.articulos[0]
               : (a.articulos && a.articulos[0] ? a.articulos[0] : null);
             const patron = art && art.patronista && art.patronista[0]
               ? art.patronista[0].nombre + " " + art.patronista[0].apellido
               : "NA";
            return {
              _id: a._id,
              numero: a.numero,
              fecha: a.fecha,
              pedido: ped ? ped.idPedido : "Directa",
              idPedidos: ped ? ped._id : "",
              cortado: a.cortado,
              cliente: ped && ped.clientes && ped.clientes[0] ? ped.clientes[0].nombre_comercial : "Producción directa",
              idCliente: ped && ped.clientes && ped.clientes[0] ? ped.clientes[0]._id : "",
              codigo: art ? art.codigoCliente : "",
              articulo: art ? art.descripcion : "",
              descripcion: art ? (art.codigoCliente + " " + art.descripcion) : "",
              idArticulo: art ? art._id : "",
              fechaCancelacion: ped ? ped.fecha_cancelacion : "",
              total_piezas: cantidad,
              observaciones: a.observaciones,
              observacionesTela: a.observacionesTela,
              fechaEntrega: a.fechaEntrega,
              observacionesPedido: ped ? ped.observaciones : "",
              is_active: a.is_active,
              pedidoEditado: ped ? ped.editado : "",
              estado: a.estado,
              patronista: patron,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setOrdenesCorte(allOrdenes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_INVENTARIOS_TELAS}Existencia`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventarios = response.data;
        setInventarios(allInventarios);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

          axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allHabilitacion = response.data;
        // Array para pagination
        let arrayTabla = allHabilitacion
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              nombre: a.nombre,
              unidad: a.unidad,
              observaciones: a.observaciones,
              descripcion: a.descripcion,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setHabilitacion(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);



  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) &&
        (selectedArticulo == 0 || selectedArticulo >= a.idArticulo)&&
        (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return [a.numero, a.fecha, a.pedido, a.codigo, a.articulo, a.total_piezas, a.cortado];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes de Corte`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Pedido" , "Codigo", "Articulo", "Cantidad", "Cortado"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ordenes-Corte.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) &&
        (selectedArticulo == 0 || selectedArticulo >= a.idArticulo)&&
        (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cliente: a.cliente,
          Codigo: a.codigo,
          Articulo: a.articulo,
          Observaciones: a.observacionesPedido,
          Cantidad: a.total_piezas,
          Pedido: a.pedido,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoOrdenesCorte";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCorte",
        sheetFilter: ["Numero", "Fecha", "Cliente", "Codigo", "Articulo", "Observaciones", "Cantidad", "Pedido"],
        sheetHeader: ["Numero", "Fecha", "Cliente", "Codigo", "Articulo", "Observaciones", "Cantidad", "Pedido"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) &&
        (selectedArticulo == 0 || selectedArticulo >= a.idArticulo)&&
        (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return [a.numero, a.fecha, a.pedido];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes de Corte`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Pedido"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Corte",
          email: mailTo,
          fileName: "ListadoOrdenesCorte.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ordenes de Corte.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Creacion", field: "fecha", sortable: false },
    { name: "Cliente", field: "cliente", sortable: false },
    { name: "Codigo", field: "codigo", sortable: false },
    { name: "Articulo", field: "articulo", sortable: false },
    { name: "Observaciones", field: "observacionesPedido", sortable: false },
    { name: "Fecha Cancelacion", field: "fechaCancelacion", sortable: false },
    { name: "Cantidad", field: "total_piezas", sortable: false },
    { name: "Pedido Interno", field: "pedido", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Tela", field: "Tela", sortable: false },
    { name: "Habilitacion", field: "Habilitacion", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.fecha.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.numero.toLowerCase().includes(search.toLowerCase()) ||
          comment.observacionesPedido.toLowerCase().includes(search.toLowerCase()) ||
          comment.fechaCancelacion
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          // comment.numero.toString().includes(search) ||
          comment.total_piezas.toString().includes(search) ||
          comment.pedido.toString().includes(search)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }
    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo)
      );
    }

    if (selectedCortado) {
      computedComments = computedComments.filter((e) =>
        e.cortado.includes(selectedCortado)
      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_piezas" &&
      // sorting.field != "numero" &&
      sorting.field != "pedido"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        // sorting.field == "numero" ||
        sorting.field == "total_piezas" ||
        sorting.field == "pedido")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
        // sorting.field == "numero" ||
        sorting.field == "total_piezas" ||
        sorting.field == "pedido")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedCliente,
    selectedArticulo,
    selectedCortado,
  ]);

  let totalCantidad = 0;
  let totalCortado = 0;
  let totalPendCortar = 0;

  async function PDFOC(numero, fecha, pedido, idPedidos, articulo, codigo, idArticulo, totalPiezas, observaciones, idPDFOC, cliente, patronista) {
    let temp2 = [];
    await axios
        .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${idPDFOC}`, {
            headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
        })
        .then(async (response) => {
            let allArticulosOrdenCorte = response.data;
            let colorTallaCantidad = {};

            allArticulosOrdenCorte.forEach((a) => {
                const color = a.articulosPedido[0].colores[0].name;
                const talla = a.articulosPedido[0].tallas[0].name;
                const cantidad = a.cantidad;

                if (!colorTallaCantidad[talla]) {
                    colorTallaCantidad[talla] = {};
                }
                if (!colorTallaCantidad[talla][color]) {
                    colorTallaCantidad[talla][color] = 0;
                }
                colorTallaCantidad[talla][color] += cantidad;
            });

            const tallas = Object.keys(colorTallaCantidad).sort();
            const colores = [
                ...new Set(allArticulosOrdenCorte.map((a) => a.articulosPedido[0].colores[0].name)),
            ].sort();


            await axios
                .get(`${URL_EXPLOSION}Articulo/${idArticulo}`, {
                    headers: {
                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                })
                .then(async (response) => {
                    let allExplosion = response.data;
                    let arrayExp = allExplosion
                        .map((b) => {
                            if (b.tipo == "Habilitacion") {
                                return {
                                    material: b.habilitacion[0].nombre + " " + b.habilitacion[0].descripcion,
                                    cantidadTotal: b.cantidad * totalPiezas,
                                    cantidad: b.cantidad,
                                    observaciones: b.observaciones,
                                };
                            }
                        })
                        .filter(function (el) {
                            return el != null;
                        });

                    let dataFinalHab = Object.values(arrayExp);
                    const dataHab = dataFinalHab.map((a) => {
                        return [
                            a.material,
                            a.observaciones,
                            new Intl.NumberFormat("en-US").format(a.cantidad),
                            new Intl.NumberFormat("en-US").format(a.cantidadTotal),
                        ];
                    });
                    const dataPDF = Object.values(dataHab);
                    const dataPDFLimpia = dataPDF.filter(function (el) {
                        return el != null;
                    });



                    await axios
                        .get(`${URL_EXPLOSION_GLOBAL}Pedido/${idPedidos}`, {
                            headers: {
                                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                            },
                        })
                        .then((response) => {
                            let allExplosionGlb = response.data;
                            let arrayExpGlb = allExplosionGlb
                                .map((a) => {
                                    if (a.cantidad > 0) {
                                        return {
                                            id: a._id,
                                            tela: a.telas[0].nombre,
                                            color: a.colores[0].name,
                                            cantidad: a.cantidad,
                                            unidad: a.telas[0].unidad,
                                            cantidadPrenda: a.cantidadPrenda,
                                            composicion: a.telas[0].composicion
                                        };
                                    }
                                })
                                .filter(function (el) {
                                    return el != null;
                                });

                            let dataFinalGlb = Object.values(arrayExpGlb);
                            const dataGlb = dataFinalGlb.map((a) => {
                                return [
                                    a.tela,
                                    a.color,
                                    new Intl.NumberFormat("en-US").format(a.cantidad) +
                                    " " +
                                    a.unidad,
                                    new Intl.NumberFormat("en-US").format(a.cantidadPrenda),
                                    a.composicion,
                                ];
                            });
                            const dataPDFGlb = Object.values(dataGlb);
                            const dataPDFLimpiaGlb = dataPDFGlb.filter(function (el) {
                                return el != null;
                            });

                            const doc = new jsPDF();

                            // Agregar imágenes y texto
                            var img = new Image();
                            img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
                            doc.addImage(img, "png", 150, 10, 33, 10);
                            var img2 = new Image();
                            img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
                            doc.addImage(img2, "png", 150, 20, 45, 25);
                            doc.setFont("helvetica", "bold")
                            doc.setFontSize(14);
                            doc.text(`ORDEN DE PRODUCCION`, 15, 13);
                            doc.setFont("helvetica", "normal")
                            doc.setFontSize(12);
                            doc.text(`Numero Orden de Corte # ${numero}`, 15, 20);
                            doc.text(`Fecha ${fecha}`, 15, 25);
                            doc.text(`Pedido ${pedido}`, 15, 30);
                            doc.text(`Cliente ${cliente}`, 15, 35);
                            doc.text(`Patronista ${patronista}`, 15, 40);
                            doc.setFontSize(10);
                            doc.text(`Articulo ${codigo} ${articulo}`, 15, 45);
                            var lines = doc.splitTextToSize(`Observaciones ${observaciones}`, 200);
                                    doc.text(15, 50, lines);

                            // Crear una variable para almacenar todas las filas de datos
                            const bodyData = [];

                            // Iterar sobre las tallas
                            tallas.forEach((talla) => {
                                let rowData = [talla];
                                let totalTalla = 0;

                                // Iterar sobre los colores
                                colores.forEach((color) => {
                                    const cantidad = colorTallaCantidad[talla][color] || 0;
                                    rowData.push(cantidad);
                                    totalTalla += cantidad;
                                });

                                // Agregar el total por talla al final de la fila
                                rowData.push(totalTalla);

                                // Agregar la fila de datos al conjunto de datos del cuerpo
                                bodyData.push(rowData);
                            });

                            // Calcular y agregar totales por color en una fila al final de la tabla
                            const totalesColorRow = ["Total"];
                            let totalGeneral = 0; // Inicializar el total general
                            colores.forEach((color) => {
                                let totalColor = 0;
                                tallas.forEach((talla) => {
                                    totalColor += colorTallaCantidad[talla][color] || 0;
                                });
                                totalesColorRow.push(totalColor);
                                totalGeneral += totalColor; // Sumar al total general
                            });

                            // Agregar el total general al final de la fila de totales
                            totalesColorRow.push(totalGeneral);

                            // Agregar totalesColorRow al final de bodyData
                            bodyData.push(totalesColorRow);

                            // Generar la tabla con todos los datos del cuerpo y los estilos definidos fuera del bucle
                            doc.autoTable({
                                head: [["Tallas", ...colores, "Total"]],
                                body: bodyData, // Utilizar el conjunto de datos del cuerpo
                                startY: 60,
                                styles: {
                                    fontSize: 10,
                                    cellPadding: 0.7,
                                    valign: "middle",
                                    halign: "center",
                                }, // Estilos generales de las celdas
                                headStyles: {
                                    fillColor: [41, 128, 186],
                                    textColor: [255, 255, 255],
                                    fontStyle: "bold",
                                    halign: "center",
                                }, // Estilos para el encabezado
                            });

                            doc.text(`Tela`, 15, doc.autoTable.previous.finalY + 10);
                            doc.autoTable({
                                head: [["Tela",
                                    "Color",
                                    "Cantidad",
                                    "Consumo Prenda",
                                    "Composicion",]],
                                body: dataPDFLimpiaGlb,
                                startY: doc.autoTable.previous.finalY + 13,
                                showFoot: "lastPage",
                            });

                            doc.text(`Habilitacion`, 15, doc.autoTable.previous.finalY + 10);
                            doc.autoTable({
                                head: [["Descripcion", "Observaciones", "Cantidad", "Total"]],
                                body: dataPDFLimpia,
                                startY: doc.autoTable.previous.finalY + 13,
                                showFoot: "lastPage",
                            });

                            // Guardar o mostrar el PDF
                            doc.save(`OrdenCorte-${numero}.pdf`);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch((err) => {
                    console.log(err);
                });
        })
        .catch((err) => {
            console.log(err);
        });
}


  async function requisicion(id, numero) {
    setExplosion([]);
    toggleProgreso();
    setIdEdit(id);
    setNumeroPedido(numero);
    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = await allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              activo: a.is_active,
              articulos: a.articulosPedido[0].articulos[0]._id,
              articulosCodigo:
                a.articulosPedido[0].articulos[0].codigo +
                " / " +
                a.articulosPedido[0].articulos[0].codigoCliente,
              colores: a.articulosPedido[0].colores[0]._id,
              coloresName: a.articulosPedido[0].colores[0].name,
              cantidad: a.cantidad,
              surtido: a.articulosPedido[0].surtido,
              pendiente_surtir: a.articulosPedido[0].pendiente_surtir,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["articulos"];
          groups[val] = groups[val] || {
            articulos: item.articulos,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].articulos = item.articulos;
          groups[val].articulosCodigo = item.articulosCodigo;
          return groups;
        }, []);

        let dataFinal = Object.values(agrupado);

        let agrupadoColores = data.reduce(function (groups, item) {
          const val = item["articulos"] + item["colores"];
          groups[val] = groups[val] || {
            articulos: item.articulos,
            colores: item.colores,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].articulos = item.articulos;
          groups[val].articulosCodigo = item.articulosCodigo;
          groups[val].colores = item.colores;
          groups[val].coloresName = item.coloresName;
          return groups;
        }, []);

        let dataFinalColores = Object.values(agrupadoColores);

        let temp2 = [];

        let exp = await dataFinal.map((a) => {
          axios
            .get(`${URL_EXPLOSION}Articulo/${a.articulos}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allExplosion = response.data;
              let arrayExp = allExplosion
                .map((b) => {
                  if (b.habilitacion != "") {
                    temp2.push({
                      articulos: a.articulos,
                      articulosCodigo: a.articulosCodigo,
                      material: b.habilitacion[0].nombre  + " " + b.habilitacion[0].descripcion,
                      cantidadTotal: b.cantidad * a.cantidad,
                      cantidad: b.cantidad,
                      colores: "NA",
                      coloresName: "NA",
                    });
                  }
                })
                .filter(function (el) {
                  return el != null;
                });
            })
            .catch((err) => {
              console.log(err);
            });
        });

        let expColores = await dataFinalColores.map((a) => {
          axios
            .get(`${URL_EXPLOSION}Articulo/${a.articulos}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allExplosion = response.data;
              let arrayExp = allExplosion
                .map((b) => {
                  if (b.telas != "") {
                    temp2.push({
                      articulos: a.articulos,
                      articulosCodigo: a.articulosCodigo,
                      material: b.telas[0].nombre,
                      cantidadTotal: b.cantidad * a.cantidad,
                      cantidad: b.cantidad,
                      colores: a.colores,
                      coloresName: a.coloresName,
                    });
                  }
                })
                .filter(function (el) {
                  return el != null;
                });
            })
            .catch((err) => {
              console.log(err);
            });
        });
        setExplosion(temp2);
        setTimeout(() => {
          setModalProgreso(false);
          toggleExplosion();
        }, 3500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function telasCortes(id, numero, idPedidos) {
    toggleProgreso()
    axios
      .get(`${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInputFieldsAnterior = response.data;
        let tablaTelas = allInputFieldsAnterior.map((a) => {
          setObservacionesTelas(a.ordenesCorte[0].observacionesTela);
          setFechaEntrega(a.ordenesCorte[0].fechaEntrega);
          return {
            articulo:
              a.articulos[0].codigo +
              " / " +
              a.articulos[0].codigoCliente +
              " / " +
              a.articulos[0].descripcion,
            tela: a.telas[0].nombre,
            color: a.colores[0].name,
            unidad: a.telas[0].unidad,
            cantidad: a.cantidad,
            telaNombre: a.telas[0].codigo + " / " + a.telas[0].nombre + " / " + a.colores[0].name
          };
        });
        let dataFinal = Object.values(tablaTelas);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["tela"] + item["color"];
          groups[val] = groups[val] || {
            tela: item.tela,
            color: item.color,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].tela = item.tela;
          groups[val].unidad = item.unidad;
          groups[val].color = item.color;
          groups[val].articulo = item.articulo;
          groups[val].telaNombre = item.telaNombre;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);

        setInputFieldsAnterior(agrupadoValues);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            totalCantidad = totalCantidad + a.cantidad;
            totalCortado = totalCortado + a.cortado;
            totalPendCortar = totalPendCortar + a.pendiente_cortar;
            return {
              id: a._id,
              articuloNombre:
                a.articulosPedido[0].articulos[0].codigo +
                " / " +
                a.articulosPedido[0].articulos[0].codigoCliente +
                " / " +
                a.articulosPedido[0].articulos[0].descripcion,
              idArticulo: a.articulosPedido[0].articulos[0]._id,
              cantidad: a.cantidad,
              cortado: a.cortado,
              pendiente_cortar: a.pendiente_cortar,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosOrden(data);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedOrdenCorte(id);
    setSelectedOrdenPedido(idPedidos);
    setSelectedOrdenCorteNumero(numero);
    setTimeout(() => {
      toggleTelas();
      setModalProgreso(false)
    }, 2000);
  }

  function telasCortesConsumo(id, numero) {
    toggleProgreso()
    axios
      .get(`${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInputFieldsAnterior = response.data;
        let tablaTelas = allInputFieldsAnterior.map((a) => {
          return {
            id: a._id,
            articulo:
              a.articulos[0].codigo +
              " / " +
              a.articulos[0].codigoCliente +
              " / " +
              a.articulos[0].descripcion,
            tela: a.telas[0].nombre,
            color: a.colores[0].name,
            unidad: a.telas[0].unidad,
            cantidad: a.cantidad,
            telaNombre: a.telas[0].codigo + " / " + a.telas[0].nombre + " / " + a.colores[0].name,
            consumo: a.consumo,
            piezas: a.piezas,
          };
        });
        let dataFinal = Object.values(tablaTelas);

       
        setInputFieldsAnteriorConsumo(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedOrdenCorte(id);
    setSelectedOrdenCorteNumero(numero);
    setTimeout(() => {
      toggleTelasConsumo();
      setModalProgreso(false)
    }, 1000);
  }

  const handleChangeInput = (id, event) => {
    const newInventarios = inputFieldsAnteriorConsumo.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFieldsAnteriorConsumo(newInventarios);
    ActualizaTotales();
};

  function telasCortesDev(id, numero) {
    setIdsInventario([]);
    axios
      .get(`${URL_INVENTARIOS_TELAS}/cortesDevolucion/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelasDevolucion = res.data;
        setTelasDevolucion(allTelasDevolucion);
        let result = allTelasDevolucion.map(({ _id }) => _id);
        setIdsInventario(result);
      })
      .catch((err) => {
        console.log(err);
      });
    setSelectedOrdenCorteDev(id);
    setSelectedOrdenCorteNumeroDev(numero);
    toggleTelasDev();
  }

  function BuscaRolloDev(id, event) {
    if (event.target.value.length >= 24) {
      if (idsInventario.includes(event.target.value)) {
        if (
          inputFields.filter((e) => e.idInventarioTelas == event.target.value)
            .length > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El rollo ya fue escaneado!",
            showConfirmButton: false,
          });
          const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
              i.idInventarioTelas = "";
            }
            return i;
          });
          setInputFields(newInputFields);
        } else {
          telasDevolucion.map((a) => {
            if (a._id == event.target.value) {
              let telasDevolucion = a._id;
              let tela = a.tela;
              let idTela = a.idTela;
              let unidadTela = a.unidadTela;
              let color = a.color;
              let cantidadOriginal = a.cantidad;
              let cantidad = a.cantidad;
              let compras = a.compras;
              let telasOC = a.telasOC;
              let telaCodigo = a.telaCodigo;
              let telaNombre = a.telaNombre;
              let telaColor = a.telaColor;
              let factura = a.factura;
              let proveedor = a.proveedor;
              handleChangeInputArticuloDev(
                id,
                telasDevolucion,
                tela,
                idTela,
                unidadTela,
                color,
                cantidad,
                cantidadOriginal,
                compras,
                telasOC,
                telaCodigo,
                telaNombre,
                telaColor,
                factura,
                proveedor
              );
            }
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo no pertenece al pedido o fue devuelto previamente!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputArticuloDev = (
    id,
    telasDevolucion,
    tela,
    idTela,
    unidadTela,
    color,
    cantidad,
    cantidadOriginal,
    compras,
    telasOC,
    telaCodigo,
    telaNombre,
    telaColor,
    factura,
    proveedor
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = telasDevolucion;
        i.telas = tela;
        i.idTela = idTela;
        i.unidad = unidadTela;
        i.colores = color;
        i.cantidad = cantidad;
        i.cantidadOriginal = cantidadOriginal;
        i.compras = compras;
        i.telasOC = telasOC;
        i.telaCodigo = telaCodigo;
        i.telaNombre = telaNombre;
        i.telaColor = telaColor;
        i.factura = factura;
        i.proveedor = proveedor;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesDev();
    handleAddFields();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesDev();
  };

  function ActualizaTotalesDev() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["colores"] + item["idTela"];
      groups[val] = groups[val] || {
        colores: item.colores,
        idTela: item.idTela,
        cantidad: 0,
      };
      groups[val].id = item.id;
      groups[val].cantidad += item.cantidad;
      groups[val].colores = item.colores;
      groups[val].idTela = item.idTela;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);

    let tr = 0;
    inputFields.map((a) => {
      if (a.idTela != "") {
        return (tr = tr + 1);
      }
    });
    setRollosTotalesDev(tr);
  }

  const saveTelasDev = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    let totalRollos = inputFields.length + cantidadAgrupado.length;

    try {
      inputFields.map((a) => {
        if (a.idInventarioTelas != "") {
          if (a.cantidad != a.cantidadOriginal) {
            axios
              .patch(
                `${URL_INVENTARIOS_TELAS}/${a.idInventarioTelas}`,
                {
                  cantidad:
                    parseFloat(a.cantidadOriginal) - parseFloat(a.cantidad),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios
                  .post(
                    `${URL_INVENTARIOS_TELAS}`,
                    {
                      cantidad: a.cantidad,
                      captura: 1,
                      produccion: "No",
                      telas: a.idTela,
                      colores: a.colores,
                      compras: a.compras,
                      telasOC: a.telasOC,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    totalRollos = totalRollos - 1;
                    QRGen(
                      data.data._id,
                      a.telaCodigo,
                      a.telaNombre,
                      a.telaColor,
                      a.cantidad,
                      a.unidad,
                      a.factura,
                      a.proveedor
                    );
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Devolucion",
                            detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            axios
              .patch(
                `${URL_INVENTARIOS_TELAS}/devolucionCorte/${a.idInventarioTelas}`,
                {},
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Devolucion",
                        detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        } else {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Crear Devolucion",
                  detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        }
      });

      // Pegamos a Devoluciones Acumulado

      cantidadAgrupado.map((w) => {
        if (w.idTela != "") {
          axios
            .patch(
              `${URL_INVENTARIOS_TELAS}DevolucionCorte2`,
              {
                ordenesCorte: selectedOrdenCorteDev,
                total_cantidad: w.cantidad,
                idColor: w.colores,
                idTela: w.idTela,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalRollos = totalRollos - 1;
              if (totalRollos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Devolucion",
                      detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        } else {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Crear Devolucion",
                  detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        }
      });

      // Terminamos de post a devoluciones acumulado
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function QRGen(id, codigo, nombre, color, cantidad, unidad, factura, proveedor) {
    const doc = new jsPDF("p", "mm", [102, 80]);
    let alturaLogo = 30;
    let alturaImagen = 60;
    let alturaTexto1 = 43;
    let alturaTexto2 = 48;
    let alturaTexto3 = 53;
    let alturaTexto4 = 58;
    let alturaTexto5 = 68;
    let alturaLogo2 = 35;

    let codigoQR = id;
    var base64 = qrcode.toDataURL(codigoQR);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-Negro.png";
    doc.addImage(img, "png", 70, alturaLogo, 35, 10, null, null, 90);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 40, alturaLogo2, 60, 25, null, null, 90);
    var img3 = new Image();
    img3.src = base64;
    doc.addImage(img3, "png", 0, alturaImagen, 40, 40);

    doc.setFontSize(11);
    doc.text(`Cod ${codigo} Mod ${nombre}`, alturaTexto1, 90, null, 90);
    doc.text(`Prov. ${proveedor}`, alturaTexto2, 90, null, 90);
    doc.text(`Factura ${factura}, Color ${color}`, alturaTexto3, 90, null, 90);
    doc.text(`ID ${id}`, alturaTexto4, 90, null, 90);
    doc.setFontSize(18);
    doc.text(`Cant. ${cantidad} ${unidad}`, alturaTexto5, 90, null, 90);
    // doc.save(`QR.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  let totalCantidadMt = 0;
  let totalCantidadKg = 0;

// async function PDFTelas(
//   numero,
//   fecha,
//   pedido,
//   id,
//   total_piezas,
//   cliente,
//   articulo,
//   codigo,
//   patronista,
//   idPedido,
//   observacionesTela,
//   fechaEntrega
// ) {
//   try {
//     // ================= ARTÍCULOS ORDEN CORTE (TALLAS / COLORES) =================
//     const articulosResponse = await axios.get(
//       `${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`,
//       {
//         headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
//       }
//     );

//     const allArticulosOrdenCorte = articulosResponse.data;
//     let colorTallaCantidad = {};

//     allArticulosOrdenCorte.forEach((a) => {
//       const color = a.articulosPedido[0]?.colores[0]?.name;
//       const talla = a.articulosPedido[0]?.tallas[0]?.name;
//       const cantidad = a.cantidad;

//       if (!talla || !color) return;

//       if (!colorTallaCantidad[talla]) {
//         colorTallaCantidad[talla] = {};
//       }
//       if (!colorTallaCantidad[talla][color]) {
//         colorTallaCantidad[talla][color] = 0;
//       }
//       colorTallaCantidad[talla][color] += cantidad;
//     });

//     const tallas = Object.keys(colorTallaCantidad).sort();
//     const colores = [
//       ...new Set(
//         allArticulosOrdenCorte.map(
//           (a) => a.articulosPedido[0]?.colores[0]?.name
//         )
//       ),
//     ]
//       .filter((c) => !!c)
//       .sort();

//     // ================= CONSUMO TELAS ACUMULADOS =================
//     const consumoResponse = await axios.get(
//       `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`,
//       {
//         headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
//       }
//     );

//     const allconsumosTela = consumoResponse.data;
//     const consumoTela = allconsumosTela
//       .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
//       .map((a) => ({
//         consumo: a.consumo,
//         piezas: a.piezas,
//         telaNombre: a.telas[0].codigo + " / " + a.telas[0].nombre,
//         colorNombre: a.colores[0].name,
//       }))
//       .filter((el) => el != null);

//     let dataFinalConsumo = Object.values(consumoTela);

//     // ================= INVENTARIO TELAS =================
//     const inventarioResponse = await axios.get(
//       `${URL_INVENTARIOS_TELAS}/ordenCorte/${id}`,
//       {
//         headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
//       }
//     );

//     const allInventariosOrdenCorte = inventarioResponse.data.data;
//     let totalRollos = inventarioResponse.data.totalRollos;
//     let totalCantidadMt = 0;
//     let totalCantidadKg = 0;

//     const arrayTabla = allInventariosOrdenCorte.map((a) => {
//       if (a.unidad === "Metros") {
//         totalCantidadMt += a.cantidad;
//       } else {
//         totalCantidadKg += a.cantidad;
//       }
//       return {
//         id: a._id,
//         articulo: a.articulo,
//         proveedor: a.proveedor,
//         idProveedor: a.idProveedor,
//         factura: a.factura,
//         cantidad: a.cantidad,
//         cantidadSobrante: a.cantidadSobrante,
//         unidad: a.unidad,
//         idTela: a.idTela,
//         telaNombre: a.articulo,
//         colorNombre: a.colorNombre,
//         idColor: a.idColor,
//         cantidadString: a.cantidadString,
//         rollos: a.rollos,
//         precio: a.precio,
//         bies: a.bies, // viene del back
//       };
//     });

//     const dataFinal = arrayTabla.filter((el) => el != null);

//     // ================= COMBINAR INVENTARIO CON CONSUMOS =================
//     const combinedData = dataFinal.map((item) => {
//       const matchingConsumos = dataFinalConsumo.filter(
//         (consumoItem) =>
//           consumoItem.telaNombre === item.telaNombre &&
//           consumoItem.colorNombre === item.colorNombre
//       );

//       const totalConsumo = matchingConsumos.reduce(
//         (sum, consumo) => sum + (consumo.consumo || 0),
//         0
//       );
//       const totalPiezas = matchingConsumos.reduce(
//         (sum, consumo) => sum + (consumo.piezas || 0),
//         0
//       );

//       return {
//         ...item,
//         consumo: totalConsumo,
//         piezas: totalPiezas,
//       };
//     });

//     // ================= SEPARAR TELAS NORMALES vs BIES =================
//     const esBies = (valor) =>
//       String(valor || "").trim().toLowerCase() === "si";

//     const telasNormales = combinedData.filter(
//       (a) => a.cantidad > 0 && !esBies(a.bies)
//     );
//     const telasBies = combinedData.filter(
//       (a) => a.cantidad > 0 && esBies(a.bies)
//     );

//     const dataPDFNormales = telasNormales
//       .sort((a, b) => (a.articulo < b.articulo ? 1 : -1))
//       .map((a) => [
//         a.proveedor,
//         a.articulo,
//         a.colorNombre,
//         "$" + new Intl.NumberFormat("en-US").format(a.precio),
//         a.factura,
//         new Intl.NumberFormat("en-US").format(a.consumo),
//         new Intl.NumberFormat("en-US").format(a.piezas),
//         new Intl.NumberFormat("en-US").format(a.piezas * a.consumo),
//         new Intl.NumberFormat("en-US").format(a.cantidadSobrante),
//         a.cantidadString,
//         a.rollos,
//         new Intl.NumberFormat("en-US").format(a.cantidad) + " " + a.unidad,
//       ]);

//     const dataPDFBies = telasBies
//       .sort((a, b) => (a.articulo < b.articulo ? 1 : -1))
//       .map((a) => [
//         a.proveedor,
//         a.articulo,
//         a.colorNombre,
//         "$" + new Intl.NumberFormat("en-US").format(a.precio),
//         a.factura,
//         new Intl.NumberFormat("en-US").format(a.consumo),
//         new Intl.NumberFormat("en-US").format(a.piezas),
//         new Intl.NumberFormat("en-US").format(a.piezas * a.consumo),
//         new Intl.NumberFormat("en-US").format(a.cantidadSobrante),
//         a.cantidadString,
//         a.rollos,
//         new Intl.NumberFormat("en-US").format(a.cantidad) + " " + a.unidad,
//       ]);

//     // ================= GENERACIÓN DEL PDF =================
//     const doc = new jsPDF("landscape");
//     var img = new Image();
//     img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
//     doc.addImage(img, "png", 230, 30, 45, 15);
//     var img2 = new Image();
//     img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
//     doc.addImage(img2, "png", 120, 7, 60, 25);
//     doc.text(`Salida Tela OC # ${numero}`, 15, 20);
//     doc.setFontSize(12);
//     doc.text(`Fecha OC: ${fecha}`, 15, 25);
//     doc.text(
//       `Cantidad: ${totalCantidadMt.toFixed(2)} Mts / ${totalCantidadKg.toFixed(
//         2
//       )} Kgs / ${totalRollos} Rollos`,
//       15,
//       30
//     );
//     doc.text(`Articulo: ${codigo} ${articulo}`, 15, 35);
//     doc.text(`Fecha Entrega Tela: ${fechaEntrega}`, 15, 40);

//     doc.text(`Pedido: ${pedido}`, 180, 20);
//     doc.text(`Cliente: ${cliente}`, 180, 25);
//     doc.text(`Patronista: ${patronista}`, 180, 30);
//     doc.text(`Piezas: ${total_piezas}`, 180, 35);

//     // ===== TABLA TALLAS x COLORES =====
//     const bodyData = [];

//     tallas.forEach((talla) => {
//       let rowData = [talla];
//       let totalTalla = 0;

//       colores.forEach((color) => {
//         const cantidad =
//           (colorTallaCantidad[talla] &&
//             colorTallaCantidad[talla][color]) ||
//           0;
//         rowData.push(cantidad);
//         totalTalla += cantidad;
//       });

//       rowData.push(totalTalla);
//       bodyData.push(rowData);
//     });

//     const totalesColorRow = ["Total"];
//     let totalGeneral = 0;
//     colores.forEach((color) => {
//       let totalColor = 0;
//       tallas.forEach((talla) => {
//         totalColor +=
//           (colorTallaCantidad[talla] &&
//             colorTallaCantidad[talla][color]) ||
//           0;
//       });
//       totalesColorRow.push(totalColor);
//       totalGeneral += totalColor;
//     });
//     totalesColorRow.push(totalGeneral);
//     bodyData.push(totalesColorRow);

//     doc.autoTable({
//       head: [["Tallas", ...colores, "Total"]],
//       body: bodyData,
//       startY: 45,
//       styles: {
//         fontSize: 10,
//         cellPadding: 0.7,
//         valign: "middle",
//         halign: "center",
//       },
//       headStyles: {
//         fillColor: [41, 128, 186],
//         textColor: [255, 255, 255],
//         fontStyle: "bold",
//         halign: "center",
//       },
//     });

//     // ===== TABLAS DE TELAS (NORMALES Y BIES) =====
//     let posY = doc.autoTable.previous.finalY + 13;

//     // 1) Telas normales
//     if (dataPDFNormales.length > 0) {
//       doc.text("TELAS", 15, posY - 3);
//       doc.autoTable({
//         head: [
//           [
//             "Proveedor",
//             "Articulo",
//             "Color",
//             "Precio",
//             "Factura",
//             "Consumo",
//             "Piezas",
//             "Cant Nec",
//             "Sobrante",
//             "Rollos",
//             "Total Rollos",
//             "Cantidad",
//           ],
//         ],
//         body: dataPDFNormales,
//         startY: posY,
//         foot: [[]],
//         showFoot: "lastPage",
//       });
//       posY = doc.autoTable.previous.finalY + 10;
//     }

//     // 2) Telas BIES
//     if (dataPDFBies.length > 0) {
//       doc.text("BIES", 15, posY - 3);
//       doc.autoTable({
//         head: [
//           [
//             "Proveedor",
//             "Articulo",
//             "Color",
//             "Precio",
//             "Factura",
//             "Consumo",
//             "Piezas",
//             "Cant Nec",
//             "Sobrante",
//             "Rollos",
//             "Total Rollos",
//             "Cantidad",
//           ],
//         ],
//         body: dataPDFBies,
//         startY: posY,
//         foot: [[]],
//         showFoot: "lastPage",
//       });
//       posY = doc.autoTable.previous.finalY + 10;
//     }

//     // ===== OBSERVACIONES =====
//     const lines = doc.splitTextToSize(
//       `Observaciones: ${observacionesTela}`,
//       260
//     );
//     doc.text(15, posY, lines);

//     window.open(doc.output("bloburl"), "_blank");
//   } catch (error) {
//     console.error("Error:", error);
//   }
// }

async function PDFTelas(
  numero,
  fecha,
  pedido,
  id,
  total_piezas,
  cliente,
  articulo,
  codigo,
  patronista,
  idPedido,
  observacionesTela,
  fechaEntrega
) {
  try {
    // ================= ARTÍCULOS ORDEN CORTE (TALLAS / COLORES) =================
    const articulosResponse = await axios.get(
      `${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`,
      {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }
    );

    const allArticulosOrdenCorte = articulosResponse.data;
    let colorTallaCantidad = {};

    allArticulosOrdenCorte.forEach((a) => {
      const color = a.articulosPedido[0]?.colores[0]?.name;
      const talla = a.articulosPedido[0]?.tallas[0]?.name;
      const cantidad = a.cantidad;

      if (!talla || !color) return;

      if (!colorTallaCantidad[talla]) {
        colorTallaCantidad[talla] = {};
      }
      if (!colorTallaCantidad[talla][color]) {
        colorTallaCantidad[talla][color] = 0;
      }
      colorTallaCantidad[talla][color] += cantidad;
    });

    const tallas = Object.keys(colorTallaCantidad).sort();
    const colores = [
      ...new Set(
        allArticulosOrdenCorte.map(
          (a) => a.articulosPedido[0]?.colores[0]?.name
        )
      ),
    ]
      .filter((c) => !!c)
      .sort();

    // ================= CONSUMO TELAS ACUMULADOS =================
    const consumoResponse = await axios.get(
      `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`,
      {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }
    );

    const allconsumosTela = consumoResponse.data;
    const consumoTela = allconsumosTela
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => ({
        consumo: a.consumo,
        piezas: a.piezas,
        telaNombre: a.telas[0].codigo + " / " + a.telas[0].nombre,
        colorNombre: a.colores[0].name,
      }))
      .filter((el) => el != null);

    let dataFinalConsumo = Object.values(consumoTela);

    // ================= INVENTARIO TELAS =================
    const inventarioResponse = await axios.get(
      `${URL_INVENTARIOS_TELAS}/ordenCorte/${id}`,
      {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }
    );

    const allInventariosOrdenCorte = inventarioResponse.data.data;
    let totalRollos = inventarioResponse.data.totalRollos;
    let totalCantidadMt = 0;
    let totalCantidadKg = 0;

    const arrayTabla = allInventariosOrdenCorte.map((a) => {
      if (a.unidad === "Metros") {
        totalCantidadMt += a.cantidad;
      } else {
        totalCantidadKg += a.cantidad;
      }
      return {
        id: a._id,
        articulo: a.articulo,
        proveedor: a.proveedor,
        idProveedor: a.idProveedor,
        factura: a.factura,
        cantidad: a.cantidad,
        cantidadSobrante: a.cantidadSobrante,
        unidad: a.unidad,
        idTela: a.idTela,
        telaNombre: a.articulo,
        colorNombre: a.colorNombre,
        idColor: a.idColor,
        cantidadString: a.cantidadString,
        rollos: a.rollos,
        precio: a.precio,
        // ignoramos completamente a.bies
      };
    });

    const dataFinal = arrayTabla.filter((el) => el != null);

    // ================= COMBINAR INVENTARIO CON CONSUMOS =================
    const combinedData = dataFinal.map((item) => {
      const matchingConsumos = dataFinalConsumo.filter(
        (consumoItem) =>
          consumoItem.telaNombre === item.telaNombre &&
          consumoItem.colorNombre === item.colorNombre
      );

      const totalConsumo = matchingConsumos.reduce(
        (sum, consumo) => sum + (consumo.consumo || 0),
        0
      );
      const totalPiezas = matchingConsumos.reduce(
        (sum, consumo) => sum + (consumo.piezas || 0),
        0
      );

      return {
        ...item,
        consumo: totalConsumo,
        piezas: totalPiezas,
      };
    });

    // ===== ÚNICA TABLA DE TELAS (SIN SEPARAR BIES) =====
    const dataPDF = combinedData
      .filter((a) => a.cantidad > 0)
      .sort((a, b) => (a.articulo < b.articulo ? 1 : -1))
      .map((a) => [
        a.proveedor,
        a.articulo,
        a.colorNombre,
        "$" + new Intl.NumberFormat("en-US").format(a.precio),
        a.factura,
        new Intl.NumberFormat("en-US").format(a.consumo),
        new Intl.NumberFormat("en-US").format(a.piezas),
        new Intl.NumberFormat("en-US").format(a.piezas * a.consumo),
        new Intl.NumberFormat("en-US").format(a.cantidadSobrante),
        a.cantidadString, // detalle de rollos
        a.rollos,
        new Intl.NumberFormat("en-US").format(a.cantidad) + " " + a.unidad,
      ]);

    // ================= GENERACIÓN DEL PDF =================
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 7, 60, 25);
    doc.text(`Salida Tela OC # ${numero}`, 15, 20);
    doc.setFontSize(12);
    doc.text(`Fecha OC: ${fecha}`, 15, 25);
    doc.text(
      `Cantidad: ${totalCantidadMt.toFixed(2)} Mts / ${totalCantidadKg.toFixed(
        2
      )} Kgs / ${totalRollos} Rollos`,
      15,
      30
    );
    doc.text(`Articulo: ${codigo} ${articulo}`, 15, 35);
    doc.text(`Fecha Entrega Tela: ${fechaEntrega}`, 15, 40);

    doc.text(`Pedido: ${pedido}`, 180, 20);
    doc.text(`Cliente: ${cliente}`, 180, 25);
    doc.text(`Patronista: ${patronista}`, 180, 30);
    doc.text(`Piezas: ${total_piezas}`, 180, 35);

    // ===== TABLA TALLAS x COLORES =====
    const bodyData = [];

    tallas.forEach((talla) => {
      let rowData = [talla];
      let totalTalla = 0;

      colores.forEach((color) => {
        const cantidad =
          (colorTallaCantidad[talla] &&
            colorTallaCantidad[talla][color]) ||
          0;
        rowData.push(cantidad);
        totalTalla += cantidad;
      });

      rowData.push(totalTalla);
      bodyData.push(rowData);
    });

    const totalesColorRow = ["Total"];
    let totalGeneral = 0;
    colores.forEach((color) => {
      let totalColor = 0;
      tallas.forEach((talla) => {
        totalColor +=
          (colorTallaCantidad[talla] &&
            colorTallaCantidad[talla][color]) ||
          0;
      });
      totalesColorRow.push(totalColor);
      totalGeneral += totalColor;
    });
    totalesColorRow.push(totalGeneral);
    bodyData.push(totalesColorRow);

    doc.autoTable({
      head: [["Tallas", ...colores, "Total"]],
      body: bodyData,
      startY: 45,
      styles: {
        fontSize: 10,
        cellPadding: 0.7,
        valign: "middle",
        halign: "center",
      },
      headStyles: {
        fillColor: [41, 128, 186],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
      },
    });

    // ===== TABLA ÚNICA DE TELAS =====
    let posY = doc.autoTable.previous.finalY + 13;

    if (dataPDF.length > 0) {
      doc.text("TELAS", 15, posY - 3);
      doc.autoTable({
        head: [
          [
            "Proveedor",
            "Articulo",
            "Color",
            "Precio",
            "Factura",
            "Consumo",
            "Piezas",
            "Cant Nec",
            "Sobrante",
            "Rollos",
            "Total Rollos",
            "Cantidad",
          ],
        ],
        body: dataPDF,
        startY: posY,
        foot: [[]],
        showFoot: "lastPage",
      });
      posY = doc.autoTable.previous.finalY + 10;
    }

    // ===== OBSERVACIONES =====
    const lines = doc.splitTextToSize(
      `Observaciones: ${observacionesTela}`,
      260
    );
    doc.text(15, posY, lines);

    window.open(doc.output("bloburl"), "_blank");
  } catch (error) {
    console.error("Error:", error);
  }
}


  async function PDFTelasDetalles(
  numero,
  fecha,
  pedido,
  id,
  total_piezas,
  cliente,
  articulo,
  codigo,
  patronista
) {
  try {
    const response = await axios.get(
      `${URL_INVENTARIOS_TELAS}/ordenCorteDetalle/${id}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    let allArticulosSurtido = response.data;

    let arrayTabla = allArticulosSurtido
      .map((a) => {
        if (a.cantidad > 0) {
          return {
            id: a._id,
            articulo: a.articulo,
            proveedor: a.proveedor,
            factura: a.factura,
            cantidad: a.cantidad.toFixed(2),
            cantidadSobrante: a.cantidadSobrante,
            unidad: a.unidad,
            idTela: a.idTela,
            telaNombre: a.articulo,
            colorNombre: a.colorNombre,
            idColor: a.idColor,
            cantidadString: a.cant,
            bies: a.bies, // <-- viene de inventariostelas
          };
        }
      })
      .filter((el) => el != null);

    let dataFinal = Object.values(arrayTabla);

    // Helper para detectar bies = "Si" robusto
    const esBies = (valor) =>
      String(valor || "")
        .trim()
        .toLowerCase() === "si";

    // Separar en dos grupos
    const dataBiesSi = dataFinal.filter((a) => esBies(a.bies));
    const dataBiesNo = dataFinal.filter((a) => !esBies(a.bies));

    // Armamos filas para cada tabla
    const dataTablaNo = dataBiesNo.map((a) => [
      a.id,
      // a.bies || "No",
      a.telaNombre,
      a.colorNombre,
      new Intl.NumberFormat("en-US").format(a.cantidad) + " " + a.unidad,
    ]);

    const dataTablaSi = dataBiesSi.map((a) => [
      a.id,
      // a.bies || "Si",
      a.telaNombre,
      a.colorNombre,
      new Intl.NumberFormat("en-US").format(a.cantidad) + " " + a.unidad,
    ]);

    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 7, 60, 25);

    doc.text(`Desgloce Salida Tela OC # ${numero}`, 20, 20);
    doc.setFontSize(12);
    doc.text(`Fecha OC: ${fecha}`, 20, 25);
    doc.text(
      `Cantidad: ${totalCantidadMt.toFixed(2)} Mts ${totalCantidadKg.toFixed(
        2
      )} Kgs`,
      20,
      30
    );
    doc.text(`Observaciones: ${observacionesTelasPDF}`, 20, 35);
    doc.text(`Articulo: ${codigo} ${articulo}`, 20, 40);

    doc.text(`Pedido: ${pedido}`, 180, 20);
    doc.text(`Cliente: ${cliente}`, 180, 25);
    doc.text(`Patronista: ${patronista}`, 180, 30);
    doc.text(`Piezas: ${total_piezas}`, 180, 35);

    // ================= TABLA BIES = "No" =================
    doc.text("TELAS", 20, 55);

    doc.autoTable({
      head: [["id", "Tela", "Color", "Cantidad"]],
      body: dataTablaNo,
      startY: 60,
      showFoot: "lastPage",
    });

    let lastY = doc.autoTable.previous.finalY;

    // ================= TABLA BIES = "Si" =================
    if (dataTablaSi.length > 0) {
      doc.text("BIES", 20, lastY + 8);

      doc.autoTable({
        head: [["id", "Tela", "Color", "Cantidad"]],
        body: dataTablaSi,
        startY: lastY + 13,
        showFoot: "lastPage",
      });
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.log(err);
  }
}


  function BuscaRollo(id, event) {
    if (event.target.value.length >= 24) {
      if (inventarios.filter((e) => e._id == event.target.value)
      .length > 0)  {
      if (
        (inputFields.filter((e) => e.idInventarioTelas == event.target.value)
          .length > 0) 
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo ya fue escaneado!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      } else {
        inventarios.map((a) => {
          if (a._id == event.target.value) {
            let idInventarioTelas = a._id;
            let telas = a.telas[0].nombre;
            let idTela = a.telas[0]._id;
            let unidad = a.telas[0].unidad;
            let color = a.colores[0].name;
            let idColor = a.colores[0]._id;
            let cantidad = a.cantidad;
            let telaNombre = a.telas[0].nombre + " / " + a.colores[0].name
            
            handleChangeInputTelas(
              id,
              idInventarioTelas,
              telas,
              idTela,
              unidad,
              color,
              idColor,
              cantidad,
              telaNombre
            );
          }
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El rollo ya fue cortado previamente!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    }
    } 
    else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputTelas = (
    id,
    idInventarioTelas,
    telas,
    idTela,
    unidad,
    color,
    idColor,
    cantidad,
    telaNombre
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = idInventarioTelas;
        i.telas = telas;
        i.idTela = idTela;
        i.unidad = unidad;
        i.colores = color;
        i.idColor = idColor;
        i.cantidad = cantidad;
        i.telaNombre = telaNombre;
      }
      return i;
    });

    ActualizaTotalesSurt();
    setInputFields(newInputFields);
    handleAddFields();
  };

  function ActualizaTotalesSurt() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["idColor"] + item["idTela"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        idColor: item.idColor,
        idTela: item.idTela,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].telas = item.telas;
      groups[val].idTela = item.idTela;
      groups[val].idArticulo = item.idArticulo;
      groups[val].unidad = item.unidad;
      groups[val].idColor = item.idColor;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);
    let tr = 0;
    inputFields.map((a) => {
      if (a.idArticulo != "") {
        return (tr = tr + 1);
      }
    });
    setRollosTotales(tr);
  }

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];

    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idInventarioTelas: "",
        telas: "",
        idTela: "",
        unidad: "",
        colores: "",
        idColor: "",
        cantidad: 0,
        idArticulo: ultimo.idArticulo,
        bies: "No",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let mts = values.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);
  };

  const handleChangeInputArticulo = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idArticulo = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

    const handleChangeInputArticuloBies = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.bies = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };


  const saveTelas = async (event) => {
    event.preventDefault();
    if (fechaTelas != "" && observacionesTelas != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = inputFields.length + cantidadAgrupado.length;
      try {
        await axios
          .post(
            URL_TELAS_ORDENES_CORTE,
            {
              fecha: fechaTelas,
              ordenesCorte: selectedOrdenCorte,
              fechaEntrega: fechaEntrega,
              observaciones: observacionesTelas,
              totalMetros,
              totalKilos,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            inputFields.map((a) => {
              if (a.idTela != "") {
                axios
                  .patch(
                    `${URL_INVENTARIOS_TELAS}/ordenesCorte/${a.idInventarioTelas}`,
                    {
                      ordenesCorte: selectedOrdenCorte,
                      pedidos: selectedOrdenPedido,
                      produccion: "Si",
                      bies: a.bies,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Telas Ordenes Corte",
                            detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Telas Ordenes Corte",
                        detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });

            // Pegamos a Apartados Acumulado

            cantidadAgrupado.map((w) => {
              axios
                .post(
                  `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}`,
                  {
                    telasOrdenesCorte: data.data._id,
                    articulos: w.idArticulo,
                    telas: w.idTela,
                    colores: w.idColor,
                    cantidad: w.cantidad,
                    ordenesCorte: selectedOrdenCorte,
                    pedidos: selectedOrdenPedido,
                    fecha: fechaTelas
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Telas Ordenes Corte",
                          detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            });

            // Terminamos de post a apartados acumulado
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  const saveTelasConsumo = async (event) => {
    event.preventDefault();
    if (fechaTelas != "" && observacionesTelas != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = inputFieldsAnteriorConsumo.length
      try {
      
        inputFieldsAnteriorConsumo.map((w) => {
              axios
                .patch(
                  `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/${w.id}`,
                  {
                    consumo: w.consumo,
                    piezas: w.piezas,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Agregar Consumo y Piezas",
                          detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            });

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  function cortado(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como cortado!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE}/${id}`,
            {
              cortado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.cortado = "Si";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Cerró",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function noCortado(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como no cortado!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE}/${id}`,
            {
              cortado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.cortado = "No";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Abrió",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }
  function jalaInfo(idEdit, observ, fecha) {
    setObservacionesTelasEdit(observ);
    setFechaEntregaEdit(fecha);
    setIdEdit(idEdit);
    toggleEditObserv();
}

function editObserv(event) {
  event.preventDefault();
  axios
    .patch(
      `${process.env.REACT_APP_URL_ORDENES_CORTE}/${idEdit}`,
      {
        observacionesTela: observacionesTelasEdit,
        fechaEntrega: fechaEntregaEdit
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      axios
      .post(
        URL_LOGS,
        {
          tipo:'Editar Orden Corte',
          detalle: "Observaciones y fecha de entrega actualizadas",
          user: user.id
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      toggleEditObserv();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      window.location.reload();
    })
     .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
}

  async function jalaEdit(id, numero){
    setIdEdit(id)

    await axios
    .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
        headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
    }).then((response) => {
      let allArticulos = response.data;
      let array = allArticulos.map((a) => {
        return {
          _id: a._id,
          cantidad: a.cantidad,
          cortado: a.cortado,
          pendiente_cortar: a.pendiente_cortar,
          articulo: a.articulosPedido[0].articulos[0].codigo,
          idArticulo: a.articulosPedido[0].articulos[0]._id,
          color: a.articulosPedido[0].colores[0].name,
          idColor: a.articulosPedido[0].colores[0]._id,
          talla: a.articulosPedido[0].tallas[0].name,
          idTalla: a.articulosPedido[0].tallas[0]._id,
        };
      })
      let data = Object.values(array);

      setArticulosEdit(data);

      let totalMts = data.map((c) => parseFloat(c.cantidad));
      let TM = totalMts.reduce((t, total, index) => t + total, 0);
      setTotalPiezas(TM);
      toggleEdit()
    }).catch((err) => {
        console.log(err);
    })

  }
  
  const handleChangeInputCantidadEdit = (id, event) => {
    const newArticulosEdit = articulosEdit.map((i) => {
      if (id === i._id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosEdit(newArticulosEdit);

    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalMts = articulosEdit.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TM);
  }

 async function saveEdit() {
   let tot = articulosEdit.length;
   await axios
     .patch(
       `${URL_ORDENES_CORTE}/${idEdit}`,
       {
         cantidad: total_piezas,
       },
       {
         headers: {
           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
         },
       }
     )
     .then(() => {
       articulosEdit.map((a) => {
         axios
           .patch(
             `${URL_ARTICULOS_ORDENES_CORTE}/${a._id}`,
             {
               cantidad: a.cantidad,
             },
             {
               headers: {
                 Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
               },
             }
           )
           .then(() => {
             tot = tot - 1;
             if (tot == 0) {
               Swal.fire("Good job!", "Creado con exito", "success");
               setTimeout(() => {
                 window.location.reload();
               }, 1000);
             }
           })
           .catch((error) => {
             console.log(error);
           });
       });
     })
     .catch((err) => {
       console.log(err);
     });
 }

   function jalaHabilitacion(
    id,
    idArticulo,
    idPedido,
    idCorte,
  ) {
    setIdProcesosSalidaHab(id);
    setIdCorteHab(idCorte);
    setIdPedidoHab(idPedido);
    axios
    .get(`${URL_EXPLOSION}Articulo/${idArticulo}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulosOrdenCorte = response.data;
      let arrayTabla = allArticulosOrdenCorte
        .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
        .filter((a) => a.cantidad >= 1)
        .map((a) => {
          return {
            id: uuidv4(),
            idHabilitacion: a.habilitacion[0]._id,
            // nombre: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
            // cantidadAnterior: a.cantidad,
            cantidad: 0,
          }
        })
        .filter(function (el) {
          return el != null;
        });

      const data = Object.values(arrayTabla);
      setInputFieldsHabilitacion(data);
    })
    .catch((err) => {
      console.log(err);
    });
    toggleHabilitacion();
  }

  function saveHabilitacion(event) {
    event.preventDefault();
    let totalRollos = inputFieldsHabilitacion.length;
    axios
      .post(
        URL_HABILITACION_ORDENES_CORTES,
        {
          ordenesCorte: idCorteHab,
          pedidos: idPedidoHab,
          fecha: fechaHab,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data2) => {
        inputFieldsHabilitacion.map((a) => {
          if (a.cantidad != 0) {
            axios
              .post(
                URL_DETALLE_HABILITACION_ORDENES_CORTES,
                {
                  cantidad: a.cantidad,
                  habilitacionOrdenesCortes: data2.data._id,
                  ordenesCorte: idCorteHab,
                  pedidos: idPedidoHab,
                  habilitacion: a.idHabilitacion,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Salida de Habilitacion",
                        detalle: `Pedido ${idPedidoHab}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
          } else {
            totalRollos = totalRollos - 1;
            if (totalRollos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Salida de Habilitacion",
                    detalle: `Pedido ${idPedidoHab}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

function BuscaHabilitacion(id, selectedHabilitacion) {
  if (!selectedHabilitacion) return;

  const { _id, nombre, descripcion, unidad, costo } = selectedHabilitacion;
  handleChangeInputHabilitacion(id, _id, `${nombre} ${descripcion}`, unidad, costo);
}

const handleChangeInputHabilitacion = (id, idHabilitacion, nombre, unidad, costo) => {
  const newInputFieldsHabilitacion = inputFieldsHabilitacion.map((i) => {
    if (id === i.id) {
      return {
        ...i,
        idHabilitacion,
        nombre,
        unidad,
        costo,
      };
    }
    return i;
  });
  setInputFieldsHabilitacion(newInputFieldsHabilitacion);
};

const handleChangeCantidad = (id, cantidad) => {
  const updated = inputFieldsHabilitacion.map((i) => {
    if (i.id === id) {
      return { ...i, cantidad };
    }
    return i;
  });
  setInputFieldsHabilitacion(updated);
};

  const handleRemoveFieldsHabilitaccion = (id) => {
    const values = [...inputFieldsHabilitacion];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsHabilitacion(values);
  };

  const handleAddFieldsHabilitacion = () => {
    setInputFieldsHabilitacion([
      ...inputFieldsHabilitacion,
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0,
      },
    ]);
  };

   function jalaHabilitacionEdit(id) {
  axios
    .get(`${URL_DETALLE_HABILITACION_ORDENES_CORTES}/proceso/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulosOrdenCorte = response.data;
      let arrayTabla = allArticulosOrdenCorte
        .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
        .map((a) => {
          return {
            id: a._id,
            idHabilitacion: a.habilitacion[0]._id,
            nombre: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
            cantidadAnterior: a.cantidad,
            cantidad: a.cantidad,
            observaciones: a.habilitacionOrdenesCortes[0].observaciones,
          };
        })
        .filter((el) => el != null);

      const data = Object.values(arrayTabla);
      setEditHab(data);

      if (data.length > 0) {
        setObservacionesHab(data[0].observaciones);
      }

      toggleEditHab();
    })
    .catch((err) => {
      console.log(err);
    });
}


  const handleChangeInputHabilitacionEdit = (id, event) => {
    const newInputFieldsHabilitacion = editHab.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setEditHab(newInputFieldsHabilitacion);
  };

  function saveHabilitacionEdit(event) {
    event.preventDefault();
    let totalRollos = editHab.length;
        editHab.map((a) => {
            axios
              .patch(
                `${URL_DETALLE_HABILITACION_ORDENES_CORTES}/${a.id}`,
                {
                  habilitacion: a.idHabilitacion,
                  cantidad: a.cantidad,
                  cantidadAnterior: a.cantidadAnterior,
                  observaciones: observacionesHab,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Salida de Habilitacion",
                        detalle: `Pedido`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
        });
  }

    async function PDFOCHab(
    fecha,
    idArticulo,
    descripcion,
    ordenCorte,
    idOrdenCorte,
    cliente
  ) {

    // var fotoDany;
    // await axios
    //   .get(`${process.env.REACT_APP_URL_GETMEDIA}/${idArticulo}`, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((data) => {
    //     if (data.data.secure_url != null) {
    //       fotoDany = data.data.secure_url;
    //       //  return setFoto(data.data.secure_url)
    //     } else fotoDany = process.env.PUBLIC_URL + "sinImagen.png";
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

        await axios
          .get(`${URL_DETALLE_HABILITACION_ORDENES_CORTES}/proceso/${idOrdenCorte}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
 .then((hab) => {
  let allHabilitacionCorte = hab.data;

  // Observaciones de la primera entrada válida
  let observacionesTexto = "";
  const firstWithObs = allHabilitacionCorte.find((a) => a.cantidad > 0 && a.habilitacionOrdenesCortes.length > 0);
  if (firstWithObs) {
    observacionesTexto = firstWithObs.habilitacionOrdenesCortes[0].observaciones || "";
  }

  let arrayTablaHab = allHabilitacionCorte
    .sort((a, b) => (a.habilitacion[0].descripcion > b.habilitacion[0].descripcion ? 1 : -1))
    .map((a) => {
      if (a.cantidad > 0)
        return [
          a.habilitacionOrdenesCortes[0].fecha,
          a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
          a.cantidad,
        ];
    })
    .filter((el) => el != null);

            const dataPDFHab = Object.values(arrayTablaHab);

            const doc = new jsPDF("landscape");

            // var img3 = new Image();
            // img3.src = fotoDany;
            // doc.addImage(img3, "unknow", 230, 10, 45, 40);

            var img = new Image();
            img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
               doc.addImage(img, "png", 230, 15, 45, 15);
            var img2 = new Image();
            img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            doc.addImage(img2, "png", 120, 10, 60, 25);
            doc.setFontSize(12);
            doc.text(`Fecha: ${fecha}`, 20, 20);
            doc.text(`Cliente: ${cliente}`, 20, 25);
            doc.text(`Orden Corte: ${ordenCorte}`, 20, 30);
            doc.text(`Articulo: ${descripcion}`, 20, 35);
            doc.text(`Observaciones: ${observacionesTexto}`, 20, 40);

 doc.autoTable({
  head: [["Fecha", "Descripcion", "Cantidad"]],
  body: dataPDFHab,
  startY: 45,
  showFoot: "lastPage",
didDrawPage: (data) => {
  if (data.pageNumber === doc.internal.getNumberOfPages()) {
    const firmaY = data.cursor.y + 20;

    const pageWidth = doc.internal.pageSize.getWidth();

    const leftX = pageWidth / 4;        // 25% del ancho
    const rightX = (pageWidth / 4) * 3; // 75% del ancho

    doc.setFontSize(12);

    // Línea izquierda
    doc.text("__________________________", leftX - 35, firmaY);
    doc.text("Entregado Por", leftX - 20, firmaY + 10);

    // Línea derecha
    doc.text("__________________________", rightX - 35, firmaY);
    doc.text("Recibido Por", rightX - 20, firmaY + 10);
  }
}
});
           
            
//             doc.setFontSize(10);
//             const pageHeight = doc.internal.pageSize.height; // Altura de la página
//             const marginBottom = 40; // Margen desde el borde inferior
//             const availableSpace = pageHeight - doc.autoTable.previous.finalY - marginBottom;
            
//             // Dividimos el texto en líneas ajustadas al ancho de la página
//             let nota = `
// 1) El propósito de realizar el contrato, es tener continuidad de maquileros óptimos para la elaboración de las prendas con excelente calidad y entrega en tiempo y forma, según lo pactado.
// 2) El MAQUILERO se compromete a entregar bajo las condiciones requeridas por la EMPRESA, el producto a maquilar; REPORTANDO oportunamente (no más de dos días hábiles a partir de la fecha en que se celebra este contrato) faltantes o defectos en habilitación, corte y/o calidad en tela; Asumiendo que, si no se hace dentro de los dos días hábiles siguientes a la entrega de maquila, el maquilero se hará responsable de los gastos que conlleve la reposición de habilitación, tela o cualquier complemento que se requiera para el producto, así con algún reproceso.
// 3) El MAQUILERO deberá llevarse con el corte a maquilar, la orden de producción, habilitación, hoja de especificaciones y muestra física correspondiente al modelo a maquilar.
// 4) El MAQUILERO deberá sacar cita previa a la entrega del producto en Almacen de producto terminado, con dos días hábiles de anticipación, tomando en cuenta que los días VIERNES no hay recepción de maquila, a menos que la empresa así lo requiera.
// 5) El MAQUILERO se compromete a entregar el producto en la fecha y hora pactada junto la orden de producción y hoja de especificaciones para revisión en almacén.
// 6) El MAQUILERO deberá de llevar a la EMPRESA 2 contra muestras para autorización de confección al departamento correspondiente (calidad y diseño); Ambas en T=CH; De lo contrario se hace acreedor a una multa de $ 500.00 pesos y/o los gastos que se deriven por incumplir esta cláusula.
// 7) El MAQUILERO tiene como máximo 5 días hábiles, para entregar sus contra muestras antes mencionadas, a partir de la fecha que cargó el corte. No se efectuará ningún tipo de préstamo o pago si no se cumple con la entrega de contra muestras.
// 8) El MAQUILERO deberá entregar el modelo completo sin ningún tipo de faltantes, ya que éstos se le cobrarán a precio facturado por la empresa; En caso de tener faltantes o piezas incompletas, solicitar reposición del material requerido según sea el caso.
// 9) LA EMPRESA no aceptará maquilas parciales o incompletos a excepción de que fueran solicitados por la misma.
// 10) LA EMPRESA está obligada a realizar la entrada del producto inmediatamente y entregar su entrada correspondiente.
// 11) EL MAQUILERO se compromete a recoger y entregar el producto en el domicilio de LA EMPRESA dentro de la fecha pactada y horario establecido, de lo contrario el MAQUILERO se hace acreedor a un cargo del 25% sobre el precio pactado de maquila.
//             `;
            
//             let lines3 = doc.splitTextToSize(nota, 260);
            
//             // Calculamos la posición inicial para las notas
//             let startY = doc.autoTable.previous.finalY + 10;
            
//             // Verificamos si hay espacio suficiente para las notas y la firma
//             if (startY + lines3.length * 10 + 20 > pageHeight - marginBottom) {
//               doc.addPage(); // Agregar una nueva página si es necesario
//               startY = 20; // Reiniciar el inicio de las notas
//             }
            
//             // Renderizamos las notas
//             doc.text(15, startY, lines3);
            
            // // Ajustamos la posición de la firma
            // let firmaStartY = Math.min(pageHeight - marginBottom, startY + lines3.length * 10 + 10);
            
            // doc.setFontSize(18);
            // doc.text("Maquilero", 142, firmaStartY + 7);
            // doc.setFontSize(12);
            // doc.text("___________________", 135, firmaStartY + 0);
            
            // Abre el PDF en una nueva pestaña
            window.open(doc.output("bloburl"), "_blank");
            
          })
          .catch((err) => {
            console.log(err);
          });
   
  }

  const options2 = habilitacion.map((option) => {
  const junta = option.nombre + " " + option.desctripcion
  const firstLetter = option.nombre[0].toUpperCase();
  return {
    firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
    ...option,
    junta,
  };
});

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.ordenesCorteCreate ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCorteCreate"
                >
                  Nueva Orden
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Orden
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Corte</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-cut" style={{ marginRight: 8, color: "#8b5cf6" }} />
                Ordenes de Corte
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Cortado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCortado}
                onChange={(e) => {
                  setSelectedCortado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {articulos
                    .sort((a, b) =>
                      a.codigoCliente > b.codigoCliente ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          Cod: {a.codigoCliente} / Ref: {a.codigo} / Desc:{" "}
                          {a.descripcion}
                        </option>
                      );
                    })}
                </Input>
              </td>
            </tr>

            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                      style={
                        a.is_active == "No"
                          ? { backgroundColor: "#ed8c8c" }
                          : a.pedidoEditado == "Si"
                          ? { backgroundColor: "#ffff00" }
                          : undefined
                      }
                    >
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.cliente}</td>
                      <td>{a.codigo}</td>
                      <td>{a.articulo}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.fechaCancelacion}</td>
                      <td>{a.total_piezas}</td>
                      <td>{a.pedido}</td>
                      <td>
                        {a.is_active == "Si" ? (
                          <>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.numero,
                                  a.fecha,
                                  a.pedido,
                                  a.idPedidos,
                                  a.articulo,
                                  a.codigo,
                                  a.idArticulo,
                                  a.total_piezas,
                                  a.observaciones,
                                  a._id,
                                  a.cliente,
                                  a.patronista
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => requisicion(a._id, a.numero)}
                            >
                              <i class="fas fa-tag"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaEdit(a._id, a.numero)}
                            >
                              <i class="fas fa-cart-plus"></i>
                            </Button>
                            {a.cortado == "No" ? (
                              <span>
                                <Button
                                  color="danger"
                                  id="Cerrar"
                                  onClick={(e) => cortado(a._id)}
                                  size="sm"
                                >
                                  <i class="fas fa-cut"></i>
                                </Button>
                              </span>
                            ) : (
                              <span>
                                <Button
                                  color="primary"
                                  onClick={(e) => noCortado(a._id)}
                                  size="sm"
                                >
                                  <i class="fas fa-cut"></i>
                                </Button>
                              </span>
                            )}
                            <BajaMultiple
                              idStatus={a._id}
                              is_active={a.is_active}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_CORTE}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE}/baja`}
                            />
                          </>
                        ) : (
                          <BajaMultiple
                            idStatus={a._id}
                            is_active={a.is_active}
                            URL_BAJA={process.env.REACT_APP_URL_ORDENES_CORTE}
                            hijo={`${process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE}/baja`}
                          />
                        )}
                      </td>
                      <td>
                        {a.is_active == "Si" ? (
                          <>
                            <Button
                              color="info"
                              id="Telas"
                              size="sm"
                              onClick={(e) =>
                                telasCortesConsumo(a._id, a.numero)
                              }
                            >
                              <i class="fas fa-ruler-combined"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Telas"
                              size="sm"
                              onClick={(e) =>
                                telasCortes(a._id, a.numero, a.idPedidos)
                              }
                            >
                              <i class="fas fa-cart-plus"></i>
                            </Button>
                            <Button
                              color="success"
                              id="TelasDev"
                              size="sm"
                              onClick={(e) => telasCortesDev(a._id, a.numero)}
                            >
                              <i class="fas fa-undo-alt"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a._id,
                                  a.observacionesTela,
                                  a.fechaEntrega
                                )
                              }
                            >
                              <i class="far fa-edit"></i>{" "}
                            </Button>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFTelas(
                                  a.numero,
                                  a.fecha,
                                  a.pedido,
                                  a._id,
                                  a.total_piezas,
                                  a.cliente,
                                  a.articulo,
                                  a.codigo,
                                  a.patronista,
                                  a.idPedido,
                                  a.observacionesTela,
                                  a.fechaEntrega
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFTelasDetalles(
                                  a.numero,
                                  a.fecha,
                                  a.pedido,
                                  a._id,
                                  a.total_piezas,
                                  a.cliente,
                                  a.articulo,
                                  a.codigo,
                                  a.patronista
                                )
                              }
                            >
                              <i class="fas fa-tape"></i>
                            </Button>
                          </>
                        ) : undefined}
                      </td>
                      <td>
                        <Button
                          size="sm"
                          className="btn"
                          color="success"
                          onClick={(e) =>
                            jalaHabilitacion(
                              a.id,
                              a.idArticulo,
                              a.idPedidos,
                              a._id
                            )
                          }
                        >
                          <i class="fas fa-tag"></i>
                        </Button>
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => {
                            jalaHabilitacionEdit(a._id);
                          }}
                        >
                          <i class="far fa-edit"></i>
                        </Button>
                        <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={(e) =>
                            PDFOCHab(
                              a.fecha,
                              a.idArticulo,
                              a.descripcion,
                              a.numero,
                              a._id,
                              a.cliente
                            )
                          }
                        >
                          <i class="far fa-file-pdf"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelas} toggle={toggleTelas}>
        <ModalHeader toggle={toggleTelas}>
          <h4>
            Entrega de Tela de la Orden de Corte {selectedOrdenCorteNumero}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelas}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaTelas}
                  required
                  onChange={(e) => {
                    setFechaTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Fecha Entrega
                </Label>
                <Input
                  type="text"
                  placeholder="fechaEntrega"
                  value={fechaEntrega}
                  required
                  onChange={(e) => {
                    setFechaEntrega(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesTelas}
                  required
                  onChange={(e) => {
                    setObservacionesTelas(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            {inputFieldsAnterior != "" ? (
              <>
                <Label>Tela Asignada</Label>
                <Row>
                  <Col md={2}>
                    <Label className="mr-sm-2">Articulo</Label>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Tela</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Color</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Unidad</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Cantidad</Label>
                  </Col>
                </Row>

                {inputFieldsAnterior.map((inputFieldAnt) => (
                  <div key={inputFieldAnt.id}>
                    <Row>
                      <Col md={2}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.articulo}
                          disabled
                        />
                      </Col>
                      <Col md={3}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.telaNombre}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.color}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.unidad}
                          disabled
                        />
                      </Col>

                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.cantidad}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>
                ))}
              </>
            ) : undefined}
            <br />

            <Label>Asignar Tela</Label>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Bies</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        handleChangeInputArticulo(inputField.id, event);
                      }}
                      tabindex="-1"
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="idInventarioTelas"
                      type="string"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaRollo(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputField.telaNombre}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="unidad"
                      type="string"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="select"
                      value={inputField.bies}
                      onChange={(event) => {
                        handleChangeInputArticuloBies(inputField.id, event);
                      }}
                    >
                      <option value="No">No</option>
                      <option value="Si">Si</option>

                    </Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(totalKilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(totalMetros)}{" "}
                  mts. / {rollosTotales} Rollos
                </h4>
              </Col>
            </Row>
            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelasConsumo} toggle={toggleTelasConsumo}>
        <ModalHeader toggle={toggleTelasConsumo}>
          <h4>Agregar Consumo {selectedOrdenCorteNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelasConsumo}>
            <Label>Tela Asignada</Label>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Consumo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Piezas</Label>
              </Col>
            </Row>

            {inputFieldsAnteriorConsumo.map((inputFieldAnt) => (
              <div key={inputFieldAnt.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.articulo}
                      disabled
                    />
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.telaNombre}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.color}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.unidad}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.cantidad}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="consumo"
                      type="number"
                      value={inputFieldAnt.consumo}
                      onChange={(event) =>
                        handleChangeInput(inputFieldAnt.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="piezas"
                      type="number"
                      value={inputFieldAnt.piezas}
                      onChange={(event) =>
                        handleChangeInput(inputFieldAnt.id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelasDev} toggle={toggleTelasDev}>
        <ModalHeader toggle={toggleTelasDev}>
          <h4>
            Devolucion de Tela de la Orden de Corte{" "}
            {selectedOrdenCorteNumeroDev}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelasDev}>
            {/* <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaTelas}
                  required
                  onChange={(e) => {
                    setFechaTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesTelas}
                  required
                  onChange={(e) => {
                    setObservacionesTelas(e.target.value);
                  }}
                />
              </Col>
            </Row> */}
            {/* <br />

            <Label>Devolver Tela</Label> */}
            <Row>
              {/* <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col> */}
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad Original</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cant a Devolver</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  {/* <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        handleChangeInputArticulo(inputField.id, event);
                      }}
                      tabindex="-1"
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col> */}
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="idInventarioTelas"
                      type="string"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaRolloDev(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="tela"
                      type="text"
                      value={inputField.telas}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="unidad"
                      type="string"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidadOriginal}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(totalKilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(totalMetros)}{" "}
                  mts. / {rollosTotalesDev} Rollos
                </h4>
              </Col>
            </Row>
            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalExplosion} toggle={toggleExplosion}>
        <ModalHeader toggle={toggleExplosion}>
          <h4>Explosion</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <tr>
              <th>Articulo</th>
              <th>Material</th>
              <th>Color</th>
              <th>Cantidad</th>
              <th>Total Cant</th>
            </tr>
            {explosion.map((a) => (
              <tr>
                <td>{a.articulosCodigo}</td>
                <td>{a.material}</td>
                <td>{a.coloresName}</td>
                <td>{a.cantidad}</td>
                <td>{a.cantidadTotal}</td>
              </tr>
            ))}
          </Table>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar</h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-list" />
              <span className="form-section-title">Detalle</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Articulo</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Color</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Talla</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
          </Row>
          {articulosEdit.map((inputField) => (
            <div key={inputField._id}>
              <Row>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="articulo"
                    type="string"
                    value={inputField.articulo}
                    disabled
                  ></Input>
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="color"
                    type="string"
                    value={inputField.color}
                    disabled
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="talla"
                    type="string"
                    value={inputField.talla}
                    disabled
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="tela"
                    type="string"
                    value={inputField.cantidad}
                    onChange={(event) =>
                      handleChangeInputCantidadEdit(inputField._id, event)
                    }
                  ></Input>
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col md={5}></Col>
            <Col md={1}>
              <Label>Total Piezas</Label>
            </Col>
            <Col md={1}>
              <Label>{total_piezas}</Label>
            </Col>
          </Row>
            </div>
          </div>
          {validaBoton ? (
            <Button
              type="submit"
              className="btn btn-success"
              onClick={saveEdit}
            >
              <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
            </Button>
          ) : (
            <Button type="submit" className="btn btn-success" disabled>
              <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalEditObserv} toggle={toggleEditObserv}>
        <ModalHeader toggle={toggleEditObserv}><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar Clase</ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-clipboard-list" />
              <span className="form-section-title">Datos</span>
            </div>
            <div className="form-section-body">
          <Label className="mr-sm-2">Observaciones Tela</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={observacionesTelasEdit}
            required
            onChange={(e) => {
              setObservacionesTelasEdit(e.target.value);
            }}
          />

          <Label className="mr-sm-2">Fecha Entrega</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={fechaEntregaEdit}
            required
            onChange={(e) => {
              setFechaEntregaEdit(e.target.value);
            }}
          />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editObserv}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalHabilitacion} toggle={toggleHabilitacion}>
        <ModalHeader toggle={toggleHabilitacion}>
          <h3>Entregar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacion}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={fechaHab}
                  onChange={(event) => {
                    setFechaHab(event.target.value);
                  }}
                ></Input>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              {/* <Col md={4}>
                <Label className="mr-sm-2">Material</Label>
              </Col> */}
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFieldsHabilitacion.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  {/* <Col md={8}>
                          <Input
                            bsSize="sm"
                            name="idHabilitacion"
                            type="select"
                            value={inputField.idHabilitacion}
                            onChange={(event) => {
                              handleChangeInputHabilitacion(inputField.id, event);
                            }}
                          >
                            <option value="">Selecciona</option>
                            {habilitacion
                              .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1))
                              .map((a) => {
                                return <option value={a._id}>{a.descripcion} {a.nombre}</option>;
                              })}
                          </Input>
                        </Col> */}
                  <Col md={8}>
                    <Autocomplete
                      size="small"
                      value={
                        options2.find(
                          (opt) => opt._id === inputField.idHabilitacion
                        ) || null
                      }
                      onChange={(event, selectedHabilitacion) => {
                        BuscaHabilitacion(inputField.id, selectedHabilitacion);
                      }}
                      options={options2.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) =>
                        option.nombre + " " + option.descripcion
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.nombre} {option.descripcion}
                        </React.Fragment>
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidad}
                      onChange={(e) =>
                        handleChangeCantidad(inputField.id, e.target.value)
                      }
                    />
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFieldsHabilitacion.length === 1}
                      onClick={() =>
                        handleRemoveFieldsHabilitaccion(inputField.id)
                      }
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsHabilitacion}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalEditHab} toggle={toggleEditHab}>
        <ModalHeader toggle={toggleEditHab}>
          <h3><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacionEdit}>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-comment-dots" />
              <span className="form-section-title">Observaciones</span>
            </div>
            <div className="form-section-body">
            <Row>
              <Col md={9}>
                <Label>Observaiones</Label>
                <Input
                  bsSize="sm"
                  type="text"
                  value={observacionesHab}
                  onChange={(event) => {
                    setObservacionesHab(event.target.value);
                  }}
                ></Input>
              </Col>
            </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-list" />
              <span className="form-section-title">Detalle</span>
            </div>
            <div className="form-section-body">
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Anterior</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Nueva</Label>
              </Col>
            </Row>

            {editHab.map((a) => (
              <div key={a.id}>
                <Row>
                  <Col md={8}>
                    <Input
                      bsSize="sm"
                      name="nombre"
                      type="string"
                      value={a.nombre}
                      disabled
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidadAnterior}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacionEdit(a.id, event);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </div>
            ))}
            </div>
          </div>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoOrdenesCorte;
